import React, { useEffect, useState } from "react";
import { Box, useTheme, useMediaQuery, CircularProgress } from "@mui/material";
import Image from "../../assets/Images/bookkeeperImg.svg";
import { useDispatch } from "react-redux";
import {
  buyPlan,
  getBookkeeperPlans,
  getTransactionsStatus,
} from "../../stores/clients";
import { useNavigate } from "react-router-dom";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import BookkeeperPlanCard from "../../components/common-components/BookkeeperPlanCard";

export const Bookkeeper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLargeScreen = useMediaQuery("(max-width:1440px)");
  const [monthlyBtnLoading, setMonthlyBtnLoading] = useState(false);
  const [yearlyBtnLoading, setYearlyBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [paymentURL, setPaymentURL] = useState("");
  const [isRenew, setIsRenew] = useState(false);
  const [plans, setPlans] = useState<any>(null);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const transcationStatus = async () => {
    try {
      const response = await dispatch<any>(getTransactionsStatus()).unwrap();
      console.log(response);
      if (response?.data?.step === -1) {
        setStep(response?.data?.step);
        return;
      }
      if (response?.data?.subscription_count > 0) {
        setIsRenew(true);
      }
      setStep(response?.data?.step);
      if (response?.data?.step === 2) {
        navigate("setup");
      } else if (response?.data?.step === 3) {
        navigate("/tools/bookkeeper/dashboard");
      }
    } catch (error: any) {
      console.log(error.response?.data?.error || error.message);
    }
  };

  // Generate a link token when the component mounts
  useEffect(() => {
    transcationStatus();
  }, []);

  useEffect(() => {
    const getURL = async () => {
      try {
        const plansResponse = await dispatch<any>(
          getBookkeeperPlans()
        ).unwrap();
        if (plansResponse?.data) {
          setPlans(plansResponse?.data);
        }
      } catch (error: any) {
        console.log(error.response?.data?.error || error.message);
      }
    };

    getURL();
  }, [dispatch]);

  // Handle Plaid Link success
  const handleYearlyClick = async (plan: any) => {
    // e.preventDefault(); // Prevent any default behavior
    setYearlyBtnLoading(true);
    const response = await dispatch<any>(
      buyPlan({ planId: plan?.id?.toString() })
    ).unwrap();
    console.log("buy", response);
    setPaymentURL(response?.data?.url);
    setTimeout(() => {
      window.location.href = response?.data?.url;
      setYearlyBtnLoading(false);
    }, 1000);
  };

  // Handle Plaid Link success
  const handleMonthlyClick = async (plan: any) => {
    //e.preventDefault(); // Prevent any default behavior
    setMonthlyBtnLoading(true);
    const response = await dispatch<any>(
      buyPlan({ planId: plan?.id?.toString() })
    ).unwrap();
    console.log("buy", response);
    setPaymentURL(response?.data?.url);
    setTimeout(() => {
      window.location.href = response?.data?.url;
      setYearlyBtnLoading(false);
    }, 1000);
  };

  useEffect(() => {
    let interval: any;

    if (step === -1) {
      interval = setInterval(() => {
        transcationStatus();
      }, 10000);
    }

    // Always clean up interval on unmount or step change
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [step]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return <ListLoadingNew />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: isMobile ? 0 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: isMobile ? "auto" : "100%",
          width: "100%",
          padding: isMobile ? 0 : 2,
          bgcolor: "white",
          marginTop: 1,
          paddingTop: isMobile ? 2 : 5,
          paddingBottom: 5,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <img
            src={Image}
            alt="Operating Agreement"
            style={{
              width: isMobile ? "150px" : isLargeScreen ? "200px" : "256px",
              height: isMobile ? "150px" : isLargeScreen ? "210px" : "268px",
            }}
          />
          <div
            style={{
              marginTop: isMobile ? "20px" : "8px",
              display: "grid",
              padding: isMobile ? "0 12px" : "0",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "20px" : isTablet ? "24px" : "28px",
                fontWeight: 700,
                textAlign: "center",
                margin: 0,
              }}
            >
              {isRenew
                ? "No active bookkeeping plan found"
                : "Access Smart Bookkeeping"}
            </p>
            <p
              style={{
                fontSize: isMobile ? "14px" : isTablet ? "15px" : "16px",
                color: "#6C6F71",
                width: isMobile ? "100%" : isTablet ? "400px" : "528px",
                textAlign: "center",
                marginTop: isMobile ? 8 : 12,
                margin: "auto",
              }}
            >
              {isRenew
                ? "You no longer have access to bookkeeping features. To continue managing your finances , please reactivate your subscription."
                : "Manage your finances with automated tracking, balance sheets, and easy tax prep — all in one place."}
            </p>
            <div
              style={{
                display: isMobile ? "grid" : "flex",
                justifyItems: "center",
                gap: isMobile ? 0 : 25,
                margin: "auto",
              }}
            >
              {Array.isArray(plans) &&
                step !== -1 &&
                [...plans]
                  .sort((a, b) => (a?.recurring?.interval === "month" ? -1 : 1))
                  .map((plan: any) => (
                    <BookkeeperPlanCard
                      key={plan?.id}
                      type={
                        plan?.recurring?.interval === "year" ? "year" : "month"
                      }
                      title={
                        plan?.recurring?.interval === "year"
                          ? "Yearly"
                          : "Monthly"
                      }
                      price={(plan.unit_amount / 100)?.toFixed(0)}
                      btnLoading={
                        plan?.recurring?.interval === "year"
                          ? yearlyBtnLoading
                          : monthlyBtnLoading
                      }
                      handleClick={() =>
                        plan.recurring.interval === "year"
                          ? handleYearlyClick(plan)
                          : handleMonthlyClick(plan)
                      }
                    />
                  ))}
            </div>
            <div
              style={{
                marginTop: 28,
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                color: "#6C6F71",
                fontSize: isMobile ? "12px" : "16px",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                width: isMobile ? "auto" : "572px",
                height: isMobile ? "auto" : "81px",
                padding: 10,
              }}
            >
              Tax Filing comes for free if you're subscribed for bookkeeping for
              at least 6 months. Tax filer will be autoenabled in your
              dashboard.
            </div>
            {step === -1 && (
              <div
                style={{
                  //fontSize: "14px",
                  fontWeight: 500,
                  margin: "auto",
                  marginTop: isMobile ? "16px" : "22px",
                  background: "#BDBDBD30",
                  paddingTop: isMobile ? "12px" : "14px",
                  paddingBottom: isMobile ? "12px" : "14px",
                  paddingLeft: isMobile ? "24px" : "25px",
                  paddingRight: isMobile ? "24px" : "25px",
                  borderRadius: "8px",
                  color: "red",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                Your subscription payment is being processed. Please wait a
                moment.
                <CircularProgress size={20} />
              </div>
            )}
          </div>
        </Box>
      </Box>
    </Box>
  );
};
